import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FRM_89 } from "@/lib/programs/marrakechFez89";

export default function MarrakechFez89Page() {
  return <ProgramTemplate program={PROGRAM_FRM_89} variant="frm" showJourneyChronology />;
}
